import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { stripePaymentSuccessAction } from '../../../redux/actions/paymentActions';
import { useDispatch } from 'react-redux';
import { errorToast } from '../../../components/toast';
import InnerLayout from '../../../components/layouts/innerLayout';

const Success = () => {
    const dispatch = useDispatch()
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');
    const [loading, setLoading] = useState(true)
    const apiCalledRef = useRef(false);

    useEffect(() => {
        if (sessionId && !apiCalledRef.current) {
            apiCalledRef.current = true;
            dispatch(stripePaymentSuccessAction({ sessionId }, (data) => { setLoading(false) }, (data) => { setLoading(false); errorToast(data.data.message) }))
        }
    }, [sessionId, dispatch]);

    return (
        <InnerLayout module={"Payment Success"}>
            <div className="h-full flex items-center justify-center bg-gradient-to-br from-green-100 via-white to-green-50 overflow-hidden">
                {loading ? (
                    // Loading Indicator
                    <div className="flex flex-col items-center">
                        <div className="loader border-t-4 border-green-500 rounded-full w-16 h-16 animate-spin mb-4"></div>
                        <p className="text-lg text-gray-700">Processing your payment...</p>
                    </div>
                ) : (
                    <div className="bg-white p-10 rounded-lg shadow-xl text-center relative">
                        {/* Animated Checkmark */}
                        <div className="flex items-center justify-center mb-6">
                            <div className="bg-green-500 rounded-full w-24 h-24 flex items-center justify-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="white"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="w-12 h-12 animate-bounce-success"
                                >
                                    <path d="M20 6L9 17l-5-5" />
                                </svg>
                            </div>
                        </div>

                        {/* Payment Success Message */}
                        <h1 className="text-3xl font-bold text-green-600 mb-4">
                            Payment Successful!
                        </h1>
                        <p className="text-gray-700 text-lg">
                            Thank you for subscribing to our service! Your transaction was successful.
                        </p>
                        {/* <p className="text-gray-600 mt-2">
                        <span className="font-medium">Session ID:</span> <code>{sessionId}</code>
                    </p> */}

                        {/* Animated Confetti */}
                        <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
                            <div className="confetti absolute top-0 left-0 w-8 h-8 bg-green-500"></div>
                            <div className="confetti absolute top-0 right-0 w-8 h-8 bg-blue-400"></div>
                            <div className="confetti absolute bottom-0 left-0 w-8 h-8 bg-yellow-400"></div>
                            <div className="confetti absolute bottom-0 right-0 w-8 h-8 bg-red-400"></div>
                        </div>
                    </div>
                )}
            </div>
        </InnerLayout>
    );
};

export default Success;
